import { useRouter } from "next/router";
import React, { useState, useEffect, useRef } from "react";
import Image from 'next/image'
import { useGlobalContext } from "@/lib/context";

type props = {
  fetchMoreData: (pageNo: number) => void
  TotalPageCount: number;
}

const InfiniteScroll = ({ fetchMoreData, TotalPageCount }: props) => {
  const router = useRouter()
  const lastPageNo = Math.ceil(TotalPageCount)
  const { props: { pageURL } } = useGlobalContext()
  const isSearch = pageURL.includes('/search?')
  const divRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [isScrolling, setIsScrolling] = useState(false);
  const [pageup, setPageUp] = useState([{ "pageNo": 1, 'scrollPos': 0 }]);
  const [scroll, setScroll] = useState(0)
  const maxPageNo = pageup.filter(f => f.scrollPos < scroll).reduce((max, item) => (item.pageNo > max ? item.pageNo : max), 1);
  useEffect(() => {
    const pageUrl = pageURL.split(`${isSearch ? '&' : '?'}page`)[0]; 
    if (maxPageNo === 1) {
      window.history.pushState(null, '', pageURL);
    } else {
      const newURL = pageUrl + `${isSearch ? '&' : '?'}page=` + maxPageNo;
      window.history.pushState(null, '', newURL);
      router.query.page = `${maxPageNo}`;
    }
  }, [maxPageNo])

  const handleScroll = () => {
    setIsScrolling(true);
    setScroll(window.scrollY);
    const scrollTimeout = setTimeout(() => {
      setIsScrolling(false);
    }, 200);
    clearTimeout(scrollTimeout);
  };

  const callback: IntersectionObserverCallback = async (entries) => {
    const pageNo = Number(router.query.page || '1');
    if (entries[0]?.isIntersecting && (lastPageNo > pageNo) && isScrolling) {
      setLoading(true);
      const nextPageNo = pageNo + 1;
      const scrollpos = window.scrollY
      setPageUp((prev) => [...prev, { 'pageNo': nextPageNo, 'scrollPos': scrollpos }]);
      await fetchMoreData(nextPageNo);
      const pageUrl = pageURL.split(`${isSearch ? '&' : '?'}page`)[0];  //without pageno url
      const newURL = pageUrl + `${isSearch ? '&' : '?'}page=` + nextPageNo;
      window.history.pushState(null, '', newURL);
      router.query.page = `${nextPageNo}`;
      setLoading(false);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(callback);
    window.addEventListener('scroll', handleScroll);
    (divRef.current) && observer.observe(divRef.current);
    return () => {
      (divRef.current) && observer.unobserve(divRef.current);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isScrolling]);

  return <div ref={divRef} style={{ textAlign: 'center' }}>
    {/* {loading && <Image src={`/assets/images/diLoader.gif`} alt={"diLoader"} height={50} width={50} />} */}
  </div>
};

export default InfiniteScroll;